import React, { useContext, useState } from 'react'
import { ReactComponent as EditIcon } from 'assets/img/svg/Edit2.svg';
import { ReactComponent as DeleteIcon } from 'assets/img/svg/Delete.svg';
import { ReactComponent as CrossIcon } from 'assets/img/svg/CrossIcon.svg';
import DeleteDialog from './DeleteDialog';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton'
import { RolePermissions, PermissionContext } from 'appContext'
import { pages } from '../../../../common/constant'
import { checkPermission } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import IconButtonWrapper from 'views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx'


const ActionsCellComponent = ({ params, handleEditClick, handleCancelClick, handleSaveClick, deleteHandler, rowForm }) => {

  const userPermissions = RolePermissions(useContext(PermissionContext), pages['sapProfitCostCentreMapping']['id']);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    params.api.getRowMode(params?.id) === 'view' ? (
      <>
        <div className='d-flex align-items-center'>
          {checkPermission(userPermissions, 'U') && <IconButtonWrapper onClick={() => handleEditClick(params)}><EditIcon /></IconButtonWrapper>}
          {checkPermission(userPermissions, 'D') && <IconButtonWrapper className='ml-2' onClick={() => setIsDialogOpen(true)}><DeleteIcon /></IconButtonWrapper>}
        </div>
        <DeleteDialog
          open={isDialogOpen}
          setOpen={setIsDialogOpen}
          data={params?.row}
          onAgree={() => deleteHandler(params?.row)}
        />
      </>
    ) : (
      <div className='d-flex align-items-center'>
        <AButton
          variant='primary_filled'
          className='ml-0'
          updatedStyle={{ height: '28px', fontWeight: 600, fontSize: '12px', lineHeight: '16px', borderRadius: '4px' }}
          onClick={() => handleSaveClick(params)}
          disabled={!rowForm?.profitCenter || !rowForm?.businessArea || !rowForm?.costCenter?.trim() || !rowForm?.costCenterDescription?.trim() }
        >
          Save
        </AButton>
        <IconButtonWrapper className='ml-2' onClick={() => handleCancelClick(params)}><CrossIcon /></IconButtonWrapper>
      </div>
    )
  )
}

export default ActionsCellComponent